export const environment = {
  production: false,
  gtmId: "GTM-KPQTSRN",
  clarityId: "sjjxwnxdog",
  // qpilotApiUrl: "http://localhost:53121",
  qpilotApiUrl:
    import.meta.env["NG_APP_QPILOT_API_URL"] ?? "https://api-dev.qpilot.cloud",
  qpilotWebComponentsUrl: "https://elements.qpilot.cloud",
  qpilotLegacyQMCUrl: "https://merchants-dev.qpilot.cloud",
  mapsAllowedSites: [41, 105],
  chargifySiteUrl: "https://patterns-in-the-cloud-llc-clone.chargify.com",
  chargifyPublicKey: "chjs_k388sjkpxqcw9gz37k4qshqh",
  customerApplicationAllowedSites: [],
  qpilotComponentsUrl: "https://components.qpilot.cloud",
  trialPeriod: "14 day",
  recaptchaSiteKey: "6LcMhugqAAAAANjtpgK5e5yicKs_MGCTr5UNTSvA",
  termsConditionsUrl: "https://qpilot.com/terms-of-service/",
  customIntegrationsEnabled: true,
  FormIdTypeForm: "R9NgEkTu",
  softwareVersion: "Web:1.5.19",
  blobStorageUrl:
    "https://qpilotintegrationsstage.blob.core.windows.net/images/",
  // qpilotNonCoreApiUrl: "http://localhost:5083",
  qpilotNonCoreApiUrl:
    "https://qpilot-non-core-processes-app-dev-centralus.azurewebsites.net",

  nextimeApiUrl:
    "https://functions-nextime-dev-centralus.azurewebsites.net/api",
  whatsNewConfigUrl:
    "https://qpilotstoragewhatsnew.blob.core.windows.net/whats-new/whats-new-config.json",
};
// The file contents for the current environment will overwrite these during build.
